import React, { useEffect, useState } from "react";
import CounsellorNavbar from "../CounsellorLayout/CounsellorNavbar";
import CounsellorSidebar from "../CounsellorLayout/CounsellorSidebar";
import CounsellorFooter from "../CounsellorLayout/CounsellorFooter";
import { Container, Card, Table } from "react-bootstrap";
import { API_URL } from "../../../Constant";
import zoomicon from "../../../assets/img/zoomicon.png";
import "../../Counsellor/Counsellor.css";
import { FaCalendarAlt, FaCalendarCheck, FaCalendarPlus } from "react-icons/fa";


const CounsellorProfile = () => {

  const [appointments, setAppointments] = useState([]);
  const [currentTime, setCurrentTime] = useState("");
  const loginid = localStorage.getItem("loginId");


  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const response = await fetch(
          `${API_URL}api/Counsellor/GetAptDetailsForCounsellor/${loginid}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch appointments");
        }

        const data = await response.json();
        console.log("Appointments:", data);
        setAppointments(data);
      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };

    fetchAppointments();
  }, []);



  return (
    <>
      <CounsellorNavbar />
      <div className="d-flex">
        <CounsellorSidebar />

        <Container fluid className="p-4">
          {/* ✅ Display Current Date and Time */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <h2 className="cheading">Appointments</h2>

            <span
              style={{
                fontSize: "1rem",
                fontWeight: "500",
                color: "#333",
              }}
            >
              📅 {currentTime}
            </span>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Card className=" shadow-sm" style={{ padding: "0px" }}>
                <Card.Body>
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left" }}
                    >
                      📅 &nbsp;Upcomming Appointments
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }}>
                    <Table bordered hover className="responsive">
                      <thead className="ctableheading">
                        <tr>
                          <th>Sr. No.</th>
                          <th>Name</th>
                          <th>Date</th>
                          <th>Time</th>
                          {/* <th>Duration (mins)</th> */}
                          <th>Meeting Link</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "#4a4a4a" }}>
                        {appointments.length > 0 ? (
                          appointments.map((appointment, index) => (
                            <tr key={appointment.appointmentId}>
                              <td>{index + 1}</td>
                              <td>
                                {appointment.clientFirstName}{" "}
                                {appointment.clientLastName}
                              </td>
                              <td>
                                {appointment.appointmentDate}
                              </td>
                              <td>

                                {appointment.appointmentTime}

                              </td>
                              {/* <td>{appointment.duration}</td> */}
                              <td>
                                <img
                                  src={zoomicon}
                                  alt="Zoom"
                                  style={{ width: "22px", marginRight: "5px" }}
                                />
                                &nbsp;
                                <a
                                  href={appointment.zoomMeetingLink}
                                  target="_blank"
                                  className="btn btn-primary"
                                  rel="noopener noreferrer"
                                  style={{ padding: "1px 6px" }}
                                >
                                  Join
                                </a>
                                <button
                                  type="button"
                                  className="btn"
                                  style={{
                                    padding: "1px 5px",
                                    marginLeft: "10px",
                                    backgroundColor: "#5CB85C",
                                    color: "white",
                                  }}
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      appointment.zoomMeetingLink
                                    );
                                  }}
                                >
                                  Copy
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No Appointments Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div className="col-md-6">
              <Card className=" shadow-sm" style={{ padding: "0px" }}>
                <Card.Body>
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left" }}
                    >
                      <i
                        className="fas fa-calendar-alt"
                        style={{ marginRight: "5px", color: "#007bff" }}
                      ></i>
                      📅 &nbsp;Past Appointments
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }}>
                    <Table bordered hover className="responsive">
                      <thead className="ctableheading">
                        <tr style={{ color: "#4a4a4a" }}>
                          <th>Sr. No.</th>
                          <th>Name</th>
                          <th>Date</th>
                          <th>Time</th>
                          {/* <th>Duration (mins)</th> */}
                          <th>Meeting Link</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appointments.length > 0 ? (
                          appointments.map((appointment, index) => (
                            <tr key={appointment.appointmentId}>
                              <td>{index + 1}</td>
                              <td>
                                {appointment.clientFirstName}{" "}
                                {appointment.clientLastName}
                              </td>
                              <td>
                                {appointment.appointmentDate}
                              </td>
                              <td>
                                {new Date(
                                  appointment.appointmentTime
                                ).toLocaleTimeString()}
                              </td>
                              {/* <td>{appointment.duration}</td> */}
                              <td>
                                <img
                                  src={zoomicon}
                                  alt="Zoom"
                                  style={{ width: "22px", marginRight: "5px" }}
                                />
                                &nbsp;
                                <a
                                  href={appointment.zoomMeetingLink}
                                  target="_blank"
                                  className="btn btn-primary"
                                  rel="noopener noreferrer"
                                  style={{ padding: "1px 6px" }}
                                >
                                  Join
                                </a>
                                <button
                                  type="button"
                                  className="btn"
                                  style={{
                                    padding: "1px 5px",
                                    marginLeft: "10px",
                                    backgroundColor: "#5CB85C",
                                    color: "white",
                                  }}
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      appointment.zoomMeetingLink
                                    );
                                  }}
                                >
                                  Copy
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No Appointments Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </Container>

      </div>
      <CounsellorFooter />
    </>
  );
};

export default CounsellorProfile;
